import { render, staticRenderFns } from "./ModalManufacturer.vue?vue&type=template&id=6b608b94&scoped=true"
import script from "./ModalManufacturer.vue?vue&type=script&lang=js"
export * from "./ModalManufacturer.vue?vue&type=script&lang=js"
import style0 from "./ModalManufacturer.vue?vue&type=style&index=0&id=6b608b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b608b94",
  null
  
)

export default component.exports